import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { APIClient } from '../misc/APIClient';
import memoize from 'memoizee';
import { PromptServicePromiseClient } from '@taxfyle/api-internal/internal/prompt_grpc_web_pb';
import { JobServicePromiseClient } from '@taxfyle/api-internal/internal/job_grpc_web_pb';
import { JobProgressionServicePromiseClient } from '@taxfyle/api-internal/internal/job_progression_grpc_web_pb';
import { createGrpcAuthenticator } from '../misc/grpc-authenticator';
import { AnswerPromptRequest, DeletePromptRequest, GetPromptRequest, ListPromptsForJobRequest } from '@taxfyle/api-internal/internal/prompt_pb';
import { BoolInputValue, InputValue, TextInputValue, DocumentsInputValue } from '@taxfyle/api-internal/internal/question_input_value_pb';
import { StringValue } from 'google-protobuf/google/protobuf/wrappers_pb';
import { TicketServicePromiseClient } from '@taxfyle/api-internal/internal/ticket_grpc_web_pb';
import { GetJobRequest, RenameJobRequest, PlaceJobOnHoldRequest, ResumeJobRequest, ListJobQuestionsRequest, CopyJobRequest, SearchJobsRequest, SearchJobScopeOption, CompleteTaskRequest, UncompleteTaskRequest, MakeCorrectionsRequest, CompleteInfoGatheringRequest, RequestJobChampionProviderRequest } from '@taxfyle/api-internal/internal/job_pb';
import { JobScopeChangeServicePromiseClient } from '@taxfyle/api-internal/internal/job_scope_change_grpc_web_pb';
import { ApproveJobScopeChangeRequest, GetJobScopeChangeRequest, ListJobScopeChangesForCollaboratorRequest, RejectJobScopeChangeRequest } from '@taxfyle/api-internal/internal/job_scope_change_pb';
import { enableDevTools } from '../utils/grpcUtil';
import { RealtimeEvent } from '@taxfyle/api-internal/internal/realtime_pb';
import { filter } from 'rxjs/operators';
import QuestionMapper from './mappers/QuestionMapper';
import { DEFAULT, match } from '../utils/patternMatchUtil';
export var TaskAPI = /*#__PURE__*/function (_APIClient) {
  function TaskAPI(opts) {
    _classCallCheck(this, TaskAPI);
    return _callSuper(this, TaskAPI, [_objectSpread(_objectSpread({}, opts), {}, {
      globalParams: _objectSpread(_objectSpread({}, opts.globalParams), {}, {
        supported_engine_version: opts.supported_engine_version
      })
    })]);
  }

  /**
   * Completes a task, returns the updated job.
   *
   * @param {*} jobId
   * @param {*} taskId
   */
  _inherits(TaskAPI, _APIClient);
  return _createClass(TaskAPI, [{
    key: "complete",
    value: function complete(jobId, taskId) {
      return this.patch(jobId, taskId, {
        completed: true
      });
    }

    /**
     * Uncompletes a task, returns the updated job.
     *
     * @param {*} jobId
     * @param {*} taskId
     */
  }, {
    key: "uncomplete",
    value: function uncomplete(jobId, taskId) {
      return this.patch(jobId, taskId, {
        completed: false
      });
    }

    /**
     * Patches a task.
     *
     * @param {*} jobId
     * @param {*} taskId
     * @param {*} data
     */
  }, {
    key: "patch",
    value: function patch(jobId, taskId, data) {
      return this.client.patch("/jobs/".concat(jobId, "/tasks/").concat(taskId), data).then(this._data);
    }
  }]);
}(APIClient);

/**
 * API client for getting the question progression.
 */
export var QuestionAPI = /*#__PURE__*/function (_APIClient2) {
  function QuestionAPI(opts) {
    _classCallCheck(this, QuestionAPI);
    return _callSuper(this, QuestionAPI, [_objectSpread(_objectSpread({}, opts), {}, {
      globalParams: _objectSpread(_objectSpread({}, opts.globalParams), {}, {
        supported_engine_version: opts.supported_engine_version
      })
    })]);
  }

  /**
   * Gets the question progression for a particular job.
   * @param {{ job: string, answers: Array<{ id: string, answer: any }>}} payload
   */
  _inherits(QuestionAPI, _APIClient2);
  return _createClass(QuestionAPI, [{
    key: "getQuestions",
    value: function getQuestions(payload) {
      return this.client.post('/engine/questions', payload).then(this._data);
    }
  }]);
}(APIClient);
var createPromptsClient = memoize(function (baseUrl) {
  var client = new PromptServicePromiseClient(baseUrl);
  enableDevTools(client);
  return client;
});
export var PromptApi = /*#__PURE__*/function () {
  function PromptApi(opts, events$) {
    _classCallCheck(this, PromptApi);
    this.client = createPromptsClient(opts.baseURL);
    this.grpcAuthenticator = createGrpcAuthenticator({
      token$: opts.token$
    });
    this.events$ = events$.pipe(filter(function (event) {
      switch (event.getTypeCase()) {
        case RealtimeEvent.TypeCase.PROMPT_CREATED:
        case RealtimeEvent.TypeCase.PROMPT_ANSWERED:
        case RealtimeEvent.TypeCase.PROMPT_DELETED:
          return true;
      }
      return false;
    }));
  }

  /**
   * Creates and sends a prompt, as per the given request.
   */
  return _createClass(PromptApi, [{
    key: "createPrompt",
    value: (function () {
      var _createPrompt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = this.client;
              _context.t1 = request;
              _context.next = 4;
              return this.grpcAuthenticator.getMeta();
            case 4:
              _context.t2 = _context.sent;
              return _context.abrupt("return", _context.t0.createPrompt.call(_context.t0, _context.t1, _context.t2));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createPrompt(_x) {
        return _createPrompt.apply(this, arguments);
      }
      return createPrompt;
    }())
  }, {
    key: "getPrompt",
    value: function () {
      var _getPrompt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = this.client;
              _context2.t1 = new GetPromptRequest().setId(id);
              _context2.next = 4;
              return this.grpcAuthenticator.getMeta();
            case 4:
              _context2.t2 = _context2.sent;
              return _context2.abrupt("return", _context2.t0.getPrompt.call(_context2.t0, _context2.t1, _context2.t2));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getPrompt(_x2) {
        return _getPrompt.apply(this, arguments);
      }
      return getPrompt;
    }()
  }, {
    key: "listPromptsForJob",
    value: function () {
      var _listPromptsForJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        var req, result, promptsList;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              req = new ListPromptsForJobRequest().setId(params.jobId);
              if (params.after) {
                req.setPageToken(params.after);
              }
              if (params.limit) {
                req.setPageSize(params.limit);
              }
              _context3.t0 = this.client;
              _context3.t1 = req;
              _context3.next = 7;
              return this.grpcAuthenticator.getMeta();
            case 7:
              _context3.t2 = _context3.sent;
              _context3.next = 10;
              return _context3.t0.listPromptsForJob.call(_context3.t0, _context3.t1, _context3.t2);
            case 10:
              result = _context3.sent;
              promptsList = result.getPromptsList().map(function (p) {
                return p.toObject();
              });
              return _context3.abrupt("return", {
                data: promptsList,
                cursor: result.getNextPageToken()
              });
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function listPromptsForJob(_x3) {
        return _listPromptsForJob.apply(this, arguments);
      }
      return listPromptsForJob;
    }()
  }, {
    key: "answerPrompt",
    value: function () {
      var _answerPrompt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
        var answer, documentsList;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              answer = new InputValue();
              _context4.t0 = params.type;
              _context4.next = _context4.t0 === 'BOOL' ? 4 : _context4.t0 === 'DOCUMENTS' ? 6 : _context4.t0 === 'TEXT' ? 9 : 11;
              break;
            case 4:
              answer.setBoolValue(new BoolInputValue().setValue(params.answer));
              return _context4.abrupt("break", 12);
            case 6:
              documentsList = params.answer.map(function (answer) {
                return new DocumentsInputValue.DocumentsAnswerEntry().setId(answer.id).setLinkedDocumentId(answer.document_id);
              });
              answer.setDocumentsValue(new DocumentsInputValue().setSelectedDocumentsList(documentsList));
              return _context4.abrupt("break", 12);
            case 9:
              answer.setTextValue(new TextInputValue().setValue(params.answer));
              return _context4.abrupt("break", 12);
            case 11:
              throw new Error('Answering this prompt type is not supported.');
            case 12:
              _context4.t1 = this.client;
              _context4.t2 = new AnswerPromptRequest().setAnswer(answer).setId(params.id);
              _context4.next = 16;
              return this.grpcAuthenticator.getMeta();
            case 16:
              _context4.t3 = _context4.sent;
              _context4.next = 19;
              return _context4.t1.answerPrompt.call(_context4.t1, _context4.t2, _context4.t3);
            case 19:
              return _context4.abrupt("return", _context4.sent);
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function answerPrompt(_x4) {
        return _answerPrompt.apply(this, arguments);
      }
      return answerPrompt;
    }()
    /**
     * Deletes a prompt
     */
  }, {
    key: "deletePrompt",
    value: (function () {
      var _deletePrompt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = this.client;
              _context5.t1 = new DeletePromptRequest().setId(params.id);
              _context5.next = 4;
              return this.grpcAuthenticator.getMeta();
            case 4:
              _context5.t2 = _context5.sent;
              _context5.next = 7;
              return _context5.t0.deletePrompt.call(_context5.t0, _context5.t1, _context5.t2);
            case 7:
              return _context5.abrupt("return", _context5.sent);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function deletePrompt(_x5) {
        return _deletePrompt.apply(this, arguments);
      }
      return deletePrompt;
    }())
  }]);
}();
var createScopeChangeRequestClient = memoize(function (baseUrl) {
  var client = new JobScopeChangeServicePromiseClient(baseUrl);
  enableDevTools(client);
  return client;
});
export var ScopeChangeRequestApi = /*#__PURE__*/function () {
  function ScopeChangeRequestApi(opts) {
    _classCallCheck(this, ScopeChangeRequestApi);
    this.client = createScopeChangeRequestClient(opts.baseURL);
    this.grpcAuthenticator = createGrpcAuthenticator({
      token$: opts.token$
    });
  }
  return _createClass(ScopeChangeRequestApi, [{
    key: "listScopeChangeRequests",
    value: function () {
      var _listScopeChangeRequests = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(jobId) {
        var request, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              request = new ListJobScopeChangesForCollaboratorRequest().setJobId(jobId);
              _context6.t0 = this.client;
              _context6.t1 = request;
              _context6.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context6.t2 = _context6.sent;
              _context6.next = 8;
              return _context6.t0.listJobScopeChangesForCollaborator.call(_context6.t0, _context6.t1, _context6.t2);
            case 8:
              response = _context6.sent;
              return _context6.abrupt("return", response.getJobScopeChangesList().map(function (scopeChangeRequest) {
                return scopeChangeRequest.toObject();
              }));
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function listScopeChangeRequests(_x6) {
        return _listScopeChangeRequests.apply(this, arguments);
      }
      return listScopeChangeRequests;
    }()
  }, {
    key: "getScopeChangeRequestBreakdown",
    value: function () {
      var _getScopeChangeRequestBreakdown = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(scopeChangeRequestId) {
        var request, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              request = new GetJobScopeChangeRequest().setId(scopeChangeRequestId);
              _context7.t0 = this.client;
              _context7.t1 = request;
              _context7.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context7.t2 = _context7.sent;
              _context7.next = 8;
              return _context7.t0.getJobScopeChangePriceBreakdownForClient.call(_context7.t0, _context7.t1, _context7.t2);
            case 8:
              response = _context7.sent;
              return _context7.abrupt("return", response.toObject());
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getScopeChangeRequestBreakdown(_x7) {
        return _getScopeChangeRequestBreakdown.apply(this, arguments);
      }
      return getScopeChangeRequestBreakdown;
    }()
  }, {
    key: "approveScopeChangeRequest",
    value: function () {
      var _approveScopeChangeRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(jobId) {
        var request, response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              request = new ApproveJobScopeChangeRequest().setJobId(jobId);
              _context8.t0 = this.client;
              _context8.t1 = request;
              _context8.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context8.t2 = _context8.sent;
              _context8.next = 8;
              return _context8.t0.approveJobScopeChange.call(_context8.t0, _context8.t1, _context8.t2);
            case 8:
              response = _context8.sent;
              return _context8.abrupt("return", response);
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function approveScopeChangeRequest(_x8) {
        return _approveScopeChangeRequest.apply(this, arguments);
      }
      return approveScopeChangeRequest;
    }()
  }, {
    key: "rejectScopeChangeRequest",
    value: function () {
      var _rejectScopeChangeRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(jobId, reason) {
        var request, response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              request = new RejectJobScopeChangeRequest().setJobId(jobId).setReason(reason);
              _context9.t0 = this.client;
              _context9.t1 = request;
              _context9.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context9.t2 = _context9.sent;
              _context9.next = 8;
              return _context9.t0.rejectJobScopeChange.call(_context9.t0, _context9.t1, _context9.t2);
            case 8:
              response = _context9.sent;
              return _context9.abrupt("return", response);
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function rejectScopeChangeRequest(_x9, _x10) {
        return _rejectScopeChangeRequest.apply(this, arguments);
      }
      return rejectScopeChangeRequest;
    }()
  }]);
}();
var createJobProgressionClient = memoize(function (baseUrl) {
  var client = new JobProgressionServicePromiseClient(baseUrl);
  enableDevTools(client);
  return client;
});

/**
 * Job Progression API.
 */
export var JobProgressionAPI = /*#__PURE__*/function () {
  function JobProgressionAPI(opts, events$) {
    _classCallCheck(this, JobProgressionAPI);
    this.client = createJobProgressionClient(opts.baseURL);
    this.grpcAuthenticator = createGrpcAuthenticator({
      token$: opts.token$
    });
    this.events$ = events$.pipe(filter(function (event) {
      switch (event.getTypeCase()) {
        case RealtimeEvent.TypeCase.JOB_PROGRESSION:
          return true;
      }
      return false;
    }));
  }

  /**
   * Gets all steps for a job progression.
   */
  return _createClass(JobProgressionAPI, [{
    key: "getProgression",
    value: (function () {
      var _getProgression = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(request) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.t0 = this.client;
              _context10.t1 = request;
              _context10.next = 4;
              return this.grpcAuthenticator.getMeta();
            case 4:
              _context10.t2 = _context10.sent;
              return _context10.abrupt("return", _context10.t0.getJobProgression.call(_context10.t0, _context10.t1, _context10.t2));
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getProgression(_x11) {
        return _getProgression.apply(this, arguments);
      }
      return getProgression;
    }()
    /**
     * Gets all progressions specified.
     */
    )
  }, {
    key: "getManyProgression",
    value: (function () {
      var _getManyProgression = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(request) {
        var meta;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.grpcAuthenticator.getMeta();
            case 2:
              meta = _context11.sent;
              return _context11.abrupt("return", this.client.getManyJobProgressions(request, meta));
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getManyProgression(_x12) {
        return _getManyProgression.apply(this, arguments);
      }
      return getManyProgression;
    }()
    /**
     * Sets the current progression to draft rejected.
     * @param request
     * @returns
     */
    )
  }, {
    key: "setDraftRejectedProgression",
    value: (function () {
      var _setDraftRejectedProgression = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(request) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.t0 = this.client;
              _context12.t1 = request;
              _context12.next = 4;
              return this.grpcAuthenticator.getMeta();
            case 4:
              _context12.t2 = _context12.sent;
              return _context12.abrupt("return", _context12.t0.setDraftRejectedProgression.call(_context12.t0, _context12.t1, _context12.t2));
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function setDraftRejectedProgression(_x13) {
        return _setDraftRejectedProgression.apply(this, arguments);
      }
      return setDraftRejectedProgression;
    }()
    /**
     * Sets the current progression to draft approved.
     * @param request
     * @returns
     */
    )
  }, {
    key: "setDraftApprovedProgression",
    value: (function () {
      var _setDraftApprovedProgression = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(request) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.t0 = this.client;
              _context13.t1 = request;
              _context13.next = 4;
              return this.grpcAuthenticator.getMeta();
            case 4:
              _context13.t2 = _context13.sent;
              return _context13.abrupt("return", _context13.t0.setDraftApprovedProgression.call(_context13.t0, _context13.t1, _context13.t2));
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function setDraftApprovedProgression(_x14) {
        return _setDraftApprovedProgression.apply(this, arguments);
      }
      return setDraftApprovedProgression;
    }()
    /**
     * Sets the current progression to ready to file.
     */
    )
  }, {
    key: "setReadyToFileProgression",
    value: (function () {
      var _setReadyToFileProgression = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(request) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.t0 = this.client;
              _context14.t1 = request;
              _context14.next = 4;
              return this.grpcAuthenticator.getMeta();
            case 4:
              _context14.t2 = _context14.sent;
              return _context14.abrupt("return", _context14.t0.setReadyToFileProgression.call(_context14.t0, _context14.t1, _context14.t2));
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function setReadyToFileProgression(_x15) {
        return _setReadyToFileProgression.apply(this, arguments);
      }
      return setReadyToFileProgression;
    }())
  }]);
}();
var createJobTicketClient = memoize(function (baseUrl) {
  var client = new TicketServicePromiseClient(baseUrl);
  enableDevTools(client);
  return client;
});
export var JobTicketApi = /*#__PURE__*/function () {
  function JobTicketApi(opts) {
    _classCallCheck(this, JobTicketApi);
    this.client = createJobTicketClient(opts.baseURL);
    this.grpcAuthenticator = createGrpcAuthenticator({
      token$: opts.token$
    });
  }
  return _createClass(JobTicketApi, [{
    key: "getLatestOpenTicketsForJobs",
    value: function () {
      var _getLatestOpenTicketsForJobs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(request) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.t0 = this.client;
              _context15.t1 = request;
              _context15.next = 4;
              return this.grpcAuthenticator.getMeta();
            case 4:
              _context15.t2 = _context15.sent;
              return _context15.abrupt("return", _context15.t0.getLatestOpenTicketsForJobs.call(_context15.t0, _context15.t1, _context15.t2));
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function getLatestOpenTicketsForJobs(_x16) {
        return _getLatestOpenTicketsForJobs.apply(this, arguments);
      }
      return getLatestOpenTicketsForJobs;
    }()
  }]);
}();
var createJobGrpcClient = memoize(function (baseUrl) {
  var client = new JobServicePromiseClient(baseUrl);
  enableDevTools(client);
  return client;
});

/**
 * Job API V3.
 */
export var JobsV3API = /*#__PURE__*/function () {
  function JobsV3API(opts, events$) {
    _classCallCheck(this, JobsV3API);
    this.client = createJobGrpcClient(opts.baseURL);
    this.grpcAuthenticator = createGrpcAuthenticator({
      token$: opts.token$
    });
    this.events$ = events$.pipe(filter(function (event) {
      switch (event.getTypeCase()) {
        case RealtimeEvent.TypeCase.JOB_CREATED:
        case RealtimeEvent.TypeCase.JOB_UPDATED:
          return true;
      }
      return false;
    }));
  }

  /**
   * Gets a job.
   *
   * @param {string} jobId - The job id to request for.
   * @returns {Promise<Job>} The job.
   */
  return _createClass(JobsV3API, [{
    key: "getJob",
    value: (function () {
      var _getJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(jobId) {
        var request;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              request = new GetJobRequest().setId(jobId);
              _context16.t0 = this.client;
              _context16.t1 = request;
              _context16.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context16.t2 = _context16.sent;
              return _context16.abrupt("return", _context16.t0.getJob.call(_context16.t0, _context16.t1, _context16.t2).then(function (res) {
                return res.toObject();
              }));
            case 7:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function getJob(_x17) {
        return _getJob.apply(this, arguments);
      }
      return getJob;
    }()
    /**
     * Renames a job.
     *
     * @param {string} jobId.
     * @param {string} name.
     * @returns {Promise<RenameJobResponse>}
     */
    )
  }, {
    key: "rename",
    value: (function () {
      var _rename = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(jobId, name) {
        var request;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              request = new RenameJobRequest().setId(jobId).setName(name);
              _context17.t0 = this.client;
              _context17.t1 = request;
              _context17.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context17.t2 = _context17.sent;
              return _context17.abrupt("return", _context17.t0.renameJob.call(_context17.t0, _context17.t1, _context17.t2));
            case 7:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function rename(_x18, _x19) {
        return _rename.apply(this, arguments);
      }
      return rename;
    }()
    /**
     * Place job on hold
     *
     * @param {string} jobId
     * @returns {Promise<PlaceJobOnHoldResponse>}
     */
    )
  }, {
    key: "holdJob",
    value: (function () {
      var _holdJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(jobId) {
        var request;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              request = new PlaceJobOnHoldRequest().setId(jobId);
              _context18.t0 = this.client;
              _context18.t1 = request;
              _context18.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context18.t2 = _context18.sent;
              return _context18.abrupt("return", _context18.t0.placeJobOnHold.call(_context18.t0, _context18.t1, _context18.t2).then(function (res) {
                return res.toObject();
              }));
            case 7:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function holdJob(_x20) {
        return _holdJob.apply(this, arguments);
      }
      return holdJob;
    }()
    /**
     * Resume job
     *
     * @param {string} jobId
     * @returns {Promise<ResumeJobResponse>}
     */
    )
  }, {
    key: "resumeJob",
    value: (function () {
      var _resumeJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19(jobId) {
        var request;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              request = new ResumeJobRequest().setId(jobId);
              _context19.t0 = this.client;
              _context19.t1 = request;
              _context19.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context19.t2 = _context19.sent;
              return _context19.abrupt("return", _context19.t0.resumeJob.call(_context19.t0, _context19.t1, _context19.t2).then(function (res) {
                return res.toObject();
              }));
            case 7:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function resumeJob(_x21) {
        return _resumeJob.apply(this, arguments);
      }
      return resumeJob;
    }()
    /**
     * List job questions with answers.
     *
     * @param {string} jobId.
     * @param {Object[]} questions.
     */
    )
  }, {
    key: "listQuestions",
    value: (function () {
      var _listQuestions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20(jobId, questions) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              payload = new ListJobQuestionsRequest().setId(jobId);
              if (questions) {
                questions.forEach(function (question) {
                  payload.getAnswersMap().set(question.id, QuestionMapper.toDto(question));
                });
              }
              _context20.t0 = this.client;
              _context20.t1 = payload;
              _context20.next = 6;
              return this.grpcAuthenticator.getMeta();
            case 6:
              _context20.t2 = _context20.sent;
              return _context20.abrupt("return", _context20.t0.listJobQuestions.call(_context20.t0, _context20.t1, _context20.t2).then(function (response) {
                return {
                  questions: response.getQuestionsList().map(QuestionMapper.fromDto)
                };
              }));
            case 8:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function listQuestions(_x22, _x23) {
        return _listQuestions.apply(this, arguments);
      }
      return listQuestions;
    }())
  }, {
    key: "copyJob",
    value: function () {
      var _copyJob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21(jobId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              payload = new CopyJobRequest().setId(jobId);
              _context21.t0 = this.client;
              _context21.t1 = payload;
              _context21.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context21.t2 = _context21.sent;
              return _context21.abrupt("return", _context21.t0.copyJob.call(_context21.t0, _context21.t1, _context21.t2).then(function (res) {
                return res.toObject();
              }));
            case 7:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function copyJob(_x24) {
        return _copyJob.apply(this, arguments);
      }
      return copyJob;
    }()
  }, {
    key: "completeTask",
    value: function () {
      var _completeTask = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee22(jobId, taskId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              payload = new CompleteTaskRequest().setJobId(jobId).setTaskId(taskId);
              _context22.t0 = this.client;
              _context22.t1 = payload;
              _context22.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context22.t2 = _context22.sent;
              return _context22.abrupt("return", _context22.t0.completeTask.call(_context22.t0, _context22.t1, _context22.t2).then(function (res) {
                return res.toObject();
              }));
            case 7:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function completeTask(_x25, _x26) {
        return _completeTask.apply(this, arguments);
      }
      return completeTask;
    }()
  }, {
    key: "uncompleteTask",
    value: function () {
      var _uncompleteTask = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee23(jobId, taskId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              payload = new UncompleteTaskRequest().setJobId(jobId).setTaskId(taskId);
              _context23.t0 = this.client;
              _context23.t1 = payload;
              _context23.next = 5;
              return this.grpcAuthenticator.getMeta();
            case 5:
              _context23.t2 = _context23.sent;
              return _context23.abrupt("return", _context23.t0.uncompleteTask.call(_context23.t0, _context23.t1, _context23.t2).then(function (res) {
                return res.toObject();
              }));
            case 7:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function uncompleteTask(_x27, _x28) {
        return _uncompleteTask.apply(this, arguments);
      }
      return uncompleteTask;
    }()
  }, {
    key: "requestChampionProvider",
    value: function () {
      var _requestChampionProvider = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee24(jobId, providerUserPublicId) {
        var payload, championProviderIdValue;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              payload = new RequestJobChampionProviderRequest().setId(jobId);
              if (providerUserPublicId) {
                championProviderIdValue = new StringValue();
                championProviderIdValue.setValue(providerUserPublicId);
                payload.setProviderUserPublicId(championProviderIdValue);
              }
              _context24.t0 = this.client;
              _context24.t1 = payload;
              _context24.next = 6;
              return this.grpcAuthenticator.getMeta();
            case 6:
              _context24.t2 = _context24.sent;
              return _context24.abrupt("return", _context24.t0.requestChampionProvider.call(_context24.t0, _context24.t1, _context24.t2));
            case 8:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function requestChampionProvider(_x29, _x30) {
        return _requestChampionProvider.apply(this, arguments);
      }
      return requestChampionProvider;
    }()
  }, {
    key: "searchJobs",
    value: function () {
      var _searchJobs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee25(params) {
        var request;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              request = new SearchJobsRequest();
              request.setFilter(params.filter);
              request.setSearchText(params.searchText);
              request.setPageToken(params.pageToken);
              request.setPageSize(params.pageSize);
              request.setOrderBy(params.orderBy);
              request.setScope(match(params.scope, _defineProperty(_defineProperty(_defineProperty({}, JobsV3API.searchJobScopeOption.mine, function () {
                return SearchJobScopeOption.MINE;
              }), JobsV3API.searchJobScopeOption.all, function () {
                return SearchJobScopeOption.ALL;
              }), DEFAULT, function () {
                return SearchJobScopeOption.MINE;
              })));
              _context25.t0 = this.client;
              _context25.t1 = request;
              _context25.next = 11;
              return this.grpcAuthenticator.getMeta();
            case 11:
              _context25.t2 = _context25.sent;
              return _context25.abrupt("return", _context25.t0.searchJobs.call(_context25.t0, _context25.t1, _context25.t2).then(function (res) {
                return res.toObject();
              }));
            case 13:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function searchJobs(_x31) {
        return _searchJobs.apply(this, arguments);
      }
      return searchJobs;
    }()
    /**
     * Make corrections to job question answers.
     *
     * @param {string} jobId.
     * @param {Object[]} questions.
     * @param {Object[]} questions. Corrects all question answers belonging to this job.
     * @param {string} questions[].id The unique question identifier.
     * @param {string} questions[].type The question type.
     * @param {string} questions[].multi Determines if the select question type allows
     * for multiple choices.
     * @param {any} questions[].answer Its value will depend upon the question's type.
     * @param {string} reason.
     */
  }, {
    key: "makeCorrections",
    value: (function () {
      var _makeCorrections = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee26(jobId, questions, reason) {
        var _this = this;
        var payload;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              payload = new MakeCorrectionsRequest().setId(jobId).setReason(reason);
              questions.forEach(function (question) {
                payload.getAnswersMap().set(question.id, QuestionMapper.toDto(question));
              });
              _context26.t0 = this.client;
              _context26.t1 = payload;
              _context26.next = 6;
              return this.grpcAuthenticator.getMeta();
            case 6:
              _context26.t2 = _context26.sent;
              return _context26.abrupt("return", _context26.t0.makeCorrections.call(_context26.t0, _context26.t1, _context26.t2).then(function () {
                return _this.listQuestions(jobId);
              }));
            case 8:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function makeCorrections(_x32, _x33, _x34) {
        return _makeCorrections.apply(this, arguments);
      }
      return makeCorrections;
    }()
    /**
     * Complete the info gathering stage.
     *
     * @param {string} jobId
     * @param {{ completeAsAdmin: boolean }} params
     * @returns {Promise<import('@taxfyle/api-internal/internal/job_pb').CompleteInfoGatheringResponse>}
     */
    )
  }, {
    key: "completeInfoGathering",
    value: (function () {
      var _completeInfoGathering = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee27(jobId) {
        var _ref,
          _ref$completeAsAdmin,
          completeAsAdmin,
          request,
          _args27 = arguments;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _ref = _args27.length > 1 && _args27[1] !== undefined ? _args27[1] : {}, _ref$completeAsAdmin = _ref.completeAsAdmin, completeAsAdmin = _ref$completeAsAdmin === void 0 ? false : _ref$completeAsAdmin;
              request = new CompleteInfoGatheringRequest().setId(jobId).setCompleteAsAdmin(completeAsAdmin);
              _context27.t0 = this.client;
              _context27.t1 = request;
              _context27.next = 6;
              return this.grpcAuthenticator.getMeta();
            case 6:
              _context27.t2 = _context27.sent;
              return _context27.abrupt("return", _context27.t0.completeInfoGathering.call(_context27.t0, _context27.t1, _context27.t2).then(function (res) {
                return res.toObject();
              }));
            case 8:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function completeInfoGathering(_x35) {
        return _completeInfoGathering.apply(this, arguments);
      }
      return completeInfoGathering;
    }())
  }]);
}();
JobsV3API.searchJobScopeOption = {
  all: 'ALL',
  mine: 'MINE'
};
//# sourceMappingURL=API.js.map
